// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var dialogOverrides = function dialogOverrides(theme) {
  return {
    styleOverrides: {
      root: {
        maxHeight: "calc(100% - 80px)"
      },
      paperWidthXxxs: {
        width: '320px'
      },
      paperWidthXxs: {
        width: '480px'
      },
      paperWidthXs: {
        width: '576px'
      },
      paperWidthSm: {
        width: '768px'
      },
      paperWidthMd: {
        width: '1024px'
      },
      paperWidthMdLg: {
        width: '1120px'
      },
      paperWidthLg: {
        width: '1216px'
      },
      paperWidthXl: {
        width: '1540px'
      }
    }
  };
};